<template>
  <div class="page-wrapper">
    <menu-dispatcher></menu-dispatcher>

    <div class="wrapper">
      <header-dispatcher></header-dispatcher>
      <div class="screen-container">
        <div class="center-content">
          <div class="content-box">
            <div class="content-head">
              <div class="title">
                <router-link to="/directories/petrol-categories">
                  <a class="back" title="Назад"><img src="../image/back.png"></a>
                </router-link>
                {{ isNew ? 'Добавить' : 'Редактировать' }}
              </div>
              <div class="cabinet-body"></div>
            </div>
            <div class="content-body directorys-page">
              <div class="cabinet-info">
                <div class="directory-box">
                  <div class="main-content">
                    <div class="head-panel visibility">
                    </div>
                    <div class="form">
                      <div class="fieldset">
                        <label class="fieldset-title">Цена, руб.</label>
                        <fieldset :class="{'fieldset-error': errors.has('price')}">
                          <input type="number" v-model="price"
                                 v-validate="'required'" :class="{'input': true}" name="price">
                          <span v-show="errors.has('price')" class="error-text">Заполните обязательное поле</span>
                        </fieldset>
                      </div>
                      <div class="fieldset">
                        <label class="fieldset-title">Зар. плата, руб.</label>
                        <fieldset :class="{'fieldset-error': errors.has('salary')}">
                          <input type="number" v-model="salary"
                                 v-validate="'required'" :class="{'input': true}" name="salary">
                          <span v-show="errors.has('salary')" class="error-text">Заполните обязательное поле</span>
                        </fieldset>
                      </div>
                      <div class="fieldset">
                        <label class="fieldset-title">Минимальная зар. плата, руб.</label>
                        <fieldset :class="{'fieldset-error': errors.has('minSalary')}">
                          <input type="number" v-model="minSalary"
                                 v-validate="'required'" :class="{'input': true}" name="minSalary">
                          <span v-show="errors.has('minSalary')" class="error-text">Заполните обязательное поле</span>
                        </fieldset>
                      </div>
                      <div class="fieldset">
                        <label class="fieldset-title">Минимальная стоимость, руб.</label>
                        <fieldset :class="{'fieldset-error': errors.has('minPrice')}">
                          <input type="number" v-model="minPrice"
                                 v-validate="'required'" :class="{'input': true}" name="minPrice">
                          <span v-show="errors.has('minPrice')" class="error-text">Заполните обязательное поле</span>
                        </fieldset>
                      </div>
                      <div class="cashless-block">
                        <div class="fieldset">
                          <div class="title">Надбавка за безнал</div>
                        </div>
                        <div class="fieldset">
                          <label class="fieldset-title">Надбавка на единицу услуги, руб.</label>
                          <fieldset :class="{'fieldset-error': errors.has('priceSurchargeByCashless')}">
                            <input type="number" v-model="priceSurchargeByCashless"
                                   v-validate="'required'" :class="{'input': true}" name="priceSurchargeByCashless">
                            <span v-show="errors.has('priceSurchargeByCashless')" class="error-text">Заполните обязательное поле</span>
                          </fieldset>
                        </div>
                        <div class="fieldset">
                          <label class="fieldset-title">Надбавка на минимальную стоимость, руб.</label>
                          <fieldset :class="{'fieldset-error': errors.has('minPriceSurchargeByCashless')}">
                            <input type="number" v-model="minPriceSurchargeByCashless"
                                   v-validate="'required'" :class="{'input': true}" name="minPriceSurchargeByCashless">
                            <span v-show="errors.has('minPriceSurchargeByCashless')" class="error-text">Заполните обязательное поле</span>
                          </fieldset>
                        </div>
                      </div>
                      <div class="buttons">
                        <button type="button" class="save-button" @click="save">Сохранить</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
    import MenuDispatcher from '@/components/MenuDispatcher.vue'
    import HeaderDispatcher from '@/components/HeaderDispatcher.vue'
    import api from '@/api'
    import VeeValidate from 'vee-validate'

    export default {
  name: 'PetrolCategory',
  components: {
    MenuDispatcher,
    HeaderDispatcher,
    VeeValidate
  },

  data () {
    return {
      id: null,
      isNew: false,
      petrolCategory: {},
      newPetrolCategory: {}
    }
  },

  computed: {
    name: {
      get () {
        return !this.isNew ? this.petrolCategory.name : this.newPetrolCategory.name
      },

      set (name) {
        !this.isNew ? this.petrolCategory.name = name : this.newPetrolCategory.name = name
      }
    },
    price: {
      get () {
        return !this.isNew ? this.petrolCategory.price : this.newPetrolCategory.price
      },

      set (price) {
        !this.isNew ? this.petrolCategory.price = price : this.newPetrolCategory.price = price
      }
    },
    salary: {
      get () {
        return !this.isNew ? this.petrolCategory.salary : this.newPetrolCategory.salary
      },

      set (salary) {
        !this.isNew ? this.petrolCategory.salary = salary : this.newPetrolCategory.salary = salary
      }
    },
    minSalary: {
      get () {
        return !this.isNew ? this.petrolCategory.minSalary : this.newPetrolCategory.minSalary
      },

      set (minSalary) {
        !this.isNew ? this.petrolCategory.minSalary = minSalary : this.newPetrolCategory.minSalary = minSalary
      }
    },
    minPrice: {
      get () {
        return !this.isNew ? this.petrolCategory.minPrice : this.newPetrolCategory.minPrice
      },

      set (minPrice) {
        !this.isNew ? this.petrolCategory.minPrice = minPrice : this.newPetrolCategory.minPrice = minPrice
      }
    },

    priceSurchargeByCashless: {
      get () {
        return !this.isNew ? this.petrolCategory.priceSurchargeByCashless : this.newPetrolCategory.priceSurchargeByCashless
      },

      set (priceSurchargeByCashless) {
        !this.isNew ? this.petrolCategory.priceSurchargeByCashless = priceSurchargeByCashless
          : this.newPetrolCategory.priceSurchargeByCashless = priceSurchargeByCashless
      }
    },

    minPriceSurchargeByCashless: {
      get () {
        return !this.isNew ? this.petrolCategory.minPriceSurchargeByCashless : this.newPetrolCategory.minPriceSurchargeByCashless
      },

      set (minPriceSurchargeByCashless) {
        !this.isNew ? this.petrolCategory.minPriceSurchargeByCashless = minPriceSurchargeByCashless
          : this.newPetrolCategory.minPriceSurchargeByCashless = minPriceSurchargeByCashless
      }
    }
  },

  // кнопки для создания/удаления категории отсутствуют, но функционал оставлен для создания новой категории через веб,
  // на случай, если в будущем такая надобность возникнет, например, для суперадмина
  mounted () {
    let body = document.getElementsByTagName('body')[0]
    body.classList.add('cabinet-page')

    this.id = this.$route.params.id
    if (this.id == 'new') {
      this.isNew = true
      this.newPetrolCategory = {
        name: 'ГСМ',
        price: null,
        salary: null,
        minSalary: null,
        minPrice: null,
        priceSurchargeByCashless: null,
        minPriceSurchargeByCashless: null
      }
    } else {
      api
        .getPetrolCategoryById(this.id)
        .then(petrolCategory => {
          if (petrolCategory) {
            this.petrolCategory = petrolCategory
            this.isNew = false
          }
        })
    }
  },

  destroyed () {
    let body = document.getElementsByTagName('body')[0]
    body.classList.remove('cabinet-page')
  },

  methods: {
    // remove() {
    //   this.petrolCategory.removed = true;
    //   this.save();
    // },

    save () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.$store.getters.waitingApiRequestsCount != 0) { return }

          this.isNew
            ? api
              .createPetrolCategory(this.newPetrolCategory)
              .then(() => {
                this.$router.push('/directories/petrol-categories')
              })
              .catch(err => alert(err))
            : api
              .updatePetrolCategory(this.id, this.petrolCategory)
              .then(() => {
                this.$router.push('/directories/petrol-categories')
              })
              .catch(err => alert(err))
        }
      })
    }
  }
}
</script>
